module.exports = __webpack_public_path__ + "media/images/pc/stores/fukuoka/fukuoka_sns_01-217510d6654aa2dc5c5f1b9fa1e806a7.jpg";